import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  expand = true;
  value = '';

  constructor() {
  }

  ngOnInit(): void {
    const width = window.innerWidth;
    if (width <= 768) {
      this.expand = false;
    }
  }

  toggleMenu(event: boolean): void {
    this.expand = event;
  }
}
